export default __webpack_public_path__ + "static/media/add1.a01af147.PNG";